import { ReactNode, useState, MouseEvent } from 'react';
import { Popover } from '@mui/material';
import { ArrowDropDown } from '@mui/icons-material';

interface Props {
  title: string;
  children: ReactNode;
  onApply: () => void;
  onClear?: () => void;
  clearable: boolean;
  disabled?: boolean;
}

export const FilterPopover = ({
  title,
  children,
  onApply,
  onClear,
  clearable,
  disabled = false,
}: Props) => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const open = Boolean(anchorEl);
  const id = open ? title : undefined;

  const onClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const onClose = () => {
    setAnchorEl(null);
    onApply();
  };

  const activeClass = 'border-orange border-2';

  return (
    <div>
      <button
        type="button"
        aria-label={`${title} filter`}
        className={`border flex justify-between w-full px-2 lg:px-4 py-1.5 rounded-lg text-mediumgray dark:text-hintgray ${open ? activeClass : 'border-lightgray'}`}
        onClick={onClick}
        disabled={disabled}
      >
        <div className="whitespace-nowrap overflow-hidden text-ellipsis">
          {title}
        </div>
        <div>
          <ArrowDropDown />
        </div>
      </button>
      <Popover
        PaperProps={{
          sx: {
            minWidth: 320,
          },
        }}
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={onClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        {open && (
          <div className="p-4 w-full">
            {children}
            <div className="text-right mt-2">
              {!!onClear && (
                <button
                  type="button"
                  onClick={onClear}
                  className="mr-2"
                  disabled={!clearable}
                >
                  Clear

                </button>
              )}
              <button
                type="button"
                className="btn-primary"
                onClick={onClose}
              >
                Apply

              </button>
            </div>
          </div>
        )}
      </Popover>
    </div>
  );
};
